export enum EntityType {
	Business = 'business',
	Activity = 'activity',
	Area = 'area',
	Session = 'session',
	Offer = 'offer',
	Giftcard = 'giftcard',
	BookableGiftcard = 'bookablegiftcard',
	Customer = 'customer',
	User = 'user',
	GuestPrice = 'guestPrice',
	Booking = 'booking'
}
